/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useContext } from 'react';
import { LightGrayText } from '../components/flowComponents';
import { FC_DARK_BLUE, FC_LIGHTER_BLUE } from '../emotionVariables';
import SlateLogoImage from '../images/slate.png';
import { InterstitialContext } from './WelcomeInterstitial';

export const TestimonialPane = () => {
  const { largeScreenView } = useContext(InterstitialContext)

  return (
    <>
      <h2 css={css`
        color: ${FC_DARK_BLUE};
        margin-bottom: ${largeScreenView ? '54' : '40'}px;
        text-align: center;
      `}>People do their best work at Flow Club</h2>
      <div css={css`
        background: ${FC_LIGHTER_BLUE};
        border-radius: 16px;
        width: ${largeScreenView ? '360' : '311'}px;
        height: ${largeScreenView ? '242' : '188'}px;

        display: flex;
        flex-direction: column;
        align-items: center;

        margin-bottom: ${largeScreenView ? '62' : '24'}px;
      `}>
        <LightGrayText customCss={css`
          width: 281px;

          font-size: 20px;
          line-height: 28px;
          text-align: center;
          letter-spacing: 0.5px;

          margin-top: 48px;
          margin-bottom: ${largeScreenView ? '58' : '36'}px;
        `}>
          I left the session pleasantly surprised and fulfilled.
        </LightGrayText>
        <img width={45} height={14} src={SlateLogoImage} alt="Slate" />
      </div>
      <div css={css`
        font-size: 18px;
        line-height: 24px;
        text-align: center;
        letter-spacing: 0.15px;
        color: ${FC_DARK_BLUE};
      `}>
        Mia Armstrong, Slate reporter
      </div>
    </>
  )
}